import type { ReactNode } from 'react';

/**
 * The one way a screen says "you cannot change this, and here is why".
 *
 * Shown at the top of a record that is read only — by role or by state —
 * so the person knows before they type, not after a save that went nowhere.
 */
export function LockNotice({ children, tone = 'warn' }: {
  children: ReactNode;
  /** `ok` for a calm state (approved), `warn` for "ask someone else". */
  tone?: 'warn' | 'ok';
}) {
  return (
    <div className={`issue issue--${tone} lock-notice`} role="status">
      <span className="lock-notice__tag">Read only</span>
      <span className="small">{children}</span>
    </div>
  );
}
